import React from 'react';
import PropTypes from 'prop-types';
import EmptyStatePopup from './components/EmptyStatePopup/EmptyStatePopup';
import NotificationMessage from './components/NotificationMessage/NotificationMessage';
import NotificationChangedStatus from './components/NotificationChangedStatus/NotificationChangedStatus';
import NotificationRequestSubmitted from './components/NotificationRequestSubmitted/NotificatiomRequestSubmitted';
import TaskManagementCard from './components/TaskManagementCard/TaskManagementCard';
import MarkAllAsRead from './components/MarkAllAsRead/MarkAllAsRead';
import styles from './NotificationsPopup.scss';

const NotificationsPopup = ({
  notifications,
  close,
  notificationItemAction,
  taskItemAction,
  staticTexts,
  isNotificationsEmpty,
  onClickMarkAsRead,
  notificationData,
  onClickMarkAllAsRead
}) => {
  const requestNotificationCard = {
    requestCommentCreated: NotificationMessage,
    userTaggedOnRequestComment: NotificationMessage,
    requestStatusChanged: NotificationChangedStatus,
    requestSubmitted: NotificationRequestSubmitted,
    taskAssigned: TaskManagementCard,
    taskArchived: TaskManagementCard,
    taskCompleted: TaskManagementCard,
    taskUnarchived: TaskManagementCard,
    taskUnassigned: TaskManagementCard,
    taskDeleted: TaskManagementCard
  };

 return (
    <div
      className={styles.notificationsContainer}
      data-testid='alerts-popOver'
    >
      <MarkAllAsRead
        onClickMarkAllAsRead={onClickMarkAllAsRead}
        notifications={notifications}
        staticTexts={staticTexts}
        isNotificationsEmpty={isNotificationsEmpty}
      />
      <div className={styles.contentList}>
        { isNotificationsEmpty &&
              <EmptyStatePopup emptyStateMessage={staticTexts.emptyStateMessage} />
        }
        { notifications.map((notification, index) => {
          return(
            notification.items.length > 0 &&
              <div key={index}>
                <div className={styles.headerLabel}>
                    {notification.tag}
                </div>
                {notification.items.map((item, index) => {
                  const NotificationCard = requestNotificationCard[item.type];
                  return <NotificationCard
                    key={index+' card'}
                    action={notificationItemAction}
                    taskItemAction={taskItemAction}
                    close={close}
                    notification={item}
                    notificationData={notificationData}
                    onClickMarkAsRead={onClickMarkAsRead}
                    staticTexts={staticTexts}
                  />
                })}
              </div>
          )
        })}
      </div>
    </div>
  );
};

NotificationsPopup.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string,
          type: PropTypes.string,
          seen: PropTypes.bool,
          data: PropTypes.object,
        })
      )
    })
  ).isRequired,
  close: PropTypes.func.isRequired,
  notificationItemAction: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    changedStatus: PropTypes.shape({
      requestStatusStaticText: PropTypes.string,
      messageStaticText: PropTypes.string,
    }),
    commentNotification: PropTypes.shape({
      replyStaticText: PropTypes.string,
      taggedStaticText: PropTypes.string
    }),
    requestSubmitted: PropTypes.shape({
      staticText: PropTypes.string
    })
  }).isRequired,
  staticTexts: PropTypes.shape({
    emptyStateMessage: PropTypes.string,
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
    notificationsTitle: PropTypes.string,
    markAllAsRead: PropTypes.string
  }).isRequired,
  isNotificationsEmpty: PropTypes.bool,
  onClickMarkAsRead: PropTypes.func.isRequired,
  onClickMarkAllAsRead: PropTypes.func.isRequired
};

NotificationsPopup.defaultProps = {
  isNotificationsEmpty: false,
};

export default NotificationsPopup;
